// eslint-disable-next-line import/prefer-default-export
export const getImagesReviewState = (state) => state.imagesReview;
